// import jwtDecode from 'jwt-decode';
import { auth, db } from '../firebase/firebase-config';
import { getDoc, doc, collection, where, query, getDocs, updateDoc, arrayUnion } from "firebase/firestore";


// const key = "authToken";
const key = "userId";
// const user = auth.currentUser;


const storeToken  =  (authToken: string) => {
    try {
        localStorage.setItem(key, authToken);
    } catch (error) {
        console.log("Error storing auth token", error)
    }
}

const getToken = () => {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        console.log("Error getting the auth token", error)
    }
}

const storeAcademicYear = (yearId: string) => {
    try {
        localStorage.setItem('academic_year_id', yearId);
    } catch (error) {
        console.log('ERROR SAVING CODE');
    }
}

const getAcademicYear = () => {
    try {
        return localStorage.getItem('academic_year_id');
    } catch (error) {
        console.log('ERROR SAVING CODE');
    }
}

const getUser = () => {
    const token: any =  getToken();
    // console.log('STUDENT DATA: ', jwtDecode(token));

    // return token ? jwtDecode(token) : null;
}

// const isTeacher = () => {
//     const token: any =  getToken();
//     let user:any = jwtDecode(token);
//     // console.log('USER IN ISCHECK',  user)
//     return user?.role == 'teacher' ? true : false;
// }


const removeToken =  ()=> {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.log("Error removing auth token", error);
    }
}


const removeAcademicYear = () => {
    try {
        localStorage.removeItem('academic_year_id')
    } catch (error) {
        console.log('Error removing data', error)
    }
}

const storeCurrentUserId = (userId: string) => {
    try {
        if(userId){
        localStorage.setItem(key, userId);
        console.log(`USER: ${userId}`)
        }
    } catch (error) {
        console.log("Error getting user id", error)
    }
  };

  const getCurrentUserId = () => {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        console.log("Error getting the user id", error)
    }
}

  const removeCurrentUserId =  ()=> {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.log("Error removing user id", error);
    }
}

const getUserInfo = async(email: any) => {
    try {
        // console.log('EMAIL: $$$',  email)
        const q = query(collection(db, "users"), where("email", "==", email));
        let infoData = await getDocs(q);
        let allInfo:any = [];
        infoData.forEach((doc) => {
            // console.log('DOCI%%: ', doc.data())
            allInfo.push({
                id: doc.id,
                ...doc.data()
            })
        })

        return allInfo[0];
    } catch (error) {
        // console.log(error);
        console.log('Error Getting User Info')
    }
}

export { storeCurrentUserId, removeCurrentUserId, getCurrentUserId, getUserInfo, getUser, getToken, removeAcademicYear, removeToken, storeToken, storeAcademicYear, getAcademicYear }

